/* eslint-disable no-return-await */
import StaticDocuments from '../../constants/static-documents';
import RequestV2 from './request-v2.http';

export default class StaticDocumentsHttpService {
    private static uri = 'static-documents';

    public static getCurrent(document: StaticDocuments): Promise<File> {
        return RequestV2.getFileWithResponseType(`${this.uri}/current/${document}`);
    }

    public static downloadCurrent(document: StaticDocuments): Promise<void> {
        return RequestV2.downloadFile(`${this.uri}/current/${document}`);
    }
}
